<template>
  <div :class="modalTheme">
    <!-- <div class="" style="background: #b0c1b2; color: #586059; padding: 3px; border-radius: 12.5px"> -->
    <div style="background: black; color: cyan"></div>

    <h3 v-if="AreIdsShown" style="background: darkblue; color: white">WidgetSummaryGrid: inc records {{ records.length }}</h3>
    <!-- <slot :recordsSelected="recordsSelected"></slot> -->

    <DxDataGrid
      class="primaryWidgetGrid"
      :show-borders="true"
      :data-source="records"
      :selected-row-keys="selected"
      :row-alternation-enabled="true"
      :hover-state-enabled="true"
      :column-auto-width="true"
      :focused-row-enabled="true"
      :word-wrap-enabled="true"
      :ref="recordSelectionGrid"
      :key-expr="idField"
      @cell-prepared="onCellPrepared"
      noDataText="No Records were found ........"
      @exporting="onExporting"
      @toolbar-preparing="onToolbarPreparing"
    >
      <DxColumn v-if="AreIdsShown" data-field="id" caption="DRS id" />
      <DxColumn v-if="AreIdsShown" data-field="personId" caption="DRS PersonId" />

      <DxColumn data-field="priority" caption="Priority" cell-template="priority-cell" :width="60" />
      <template #priority-cell="{ data }">
        <div class="newStatusHi" style="padding: 0%">
          <div class="justify-content-center align-items-center" style="display: flex; padding: 0%; width: 100%">
            <div>
              <!-- {{ data.text }} -->

              <h6 class="mb-0" v-if="data.text === '0'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em">
                  <!-- Bottom filled circle (info) -->
                  <font-awesome-icon :icon="['fas', 'circle']" size="2x" style="color: #17a2b8; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Bell icon (white, centered) -->
                  <font-awesome-icon :icon="['fas', 'bell']" size="1x" style="color: white; position: absolute; left: 0.45em; top: 0.45em; font-size: 1.2em; z-index: 2" />
                  <!-- Top outline circle (danger) -->
                  <font-awesome-icon :icon="['far', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 3" />
                </span>
              </h6>
              <h6 class="mb-0" v-if="data.text === '1'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em; background: MistyRose; border-radius: 0.5em">
                  <!-- Bottom diamond (filled) -->
                  <font-awesome-icon :icon="['fas', 'diamond']" size="2x" style="color: #ffc107; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Exclamation, centered and larger -->
                  <font-awesome-icon :icon="['fas', 'exclamation']" size="lg" style="color: #dc3545; position: absolute; left: 0.55em; top: 0.25em; font-size: 1.5em; z-index: 2" />
                  <!-- Top diamond (outline, optional for effect) -->
                  <!-- <font-awesome-icon :icon="['fas', 'diamond']" size="2x" style="color: #ffc107; position: absolute; left: 0; top: 0; z-index: 3" /> -->
                </span>
              </h6>
              <h6 class="mb-0" v-if="data.text === '2'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em">
                  <!-- Bottom filled circle (danger) -->
                  <font-awesome-icon :icon="['fas', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Exclamation circle (white, centered) -->
                  <font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" style="color: white; position: absolute; left: 0.17em; top: 0.25em; font-size: 1.5em; z-index: 2" />
                  <!-- Top outline circle (danger) -->
                  <font-awesome-icon :icon="['far', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 3" />
                </span>
              </h6>
              <h6 class="mb-0" v-if="data.text === '3'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em">
                  <!-- Bottom filled circle (danger) -->
                  <font-awesome-icon :icon="['fas', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Exclamation circle (white, centered) -->
                  <!-- <font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" style="color: white; position: absolute; left: 0.17em; top: 0.25em; font-size: 1.5em; z-index: 2" /> -->
                  <!-- Top outline circle (danger) -->
                  <!-- <font-awesome-icon :icon="['far', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 3" /> -->
                </span>
              </h6>
            </div>
          </div>
        </div>
      </template>

      <DxColumn data-field="dueText" caption="DUE" cell-template="dueText" />
      <template #dueText="{ data }">
        <span v-if="data.data.dueText === 'Overdue'" style="background: #8a11118a; color: #e0f2e1">{{ data.data.dueText }}</span>
        <span v-else style="background: #9aa99b; color: #e3f4e5">{{ data.data.dueText }}</span>
      </template>

      <DxColumn data-field="lastName" caption="Last Name" cell-template="lastName" />
      <template #lastName="{ data }">
        <!-- <div style="background: darkgoldenrod">
          {{ data.text }}
        </div> -->
        <!-- <router-link tag="a" :to="`/Patient/${data.data.personId}`">{{ data.data.lastName }}</router-link> -->
        <b-nav pills>
          <b-nav-item :to="`/emr/Patient/${data.data.personId}`">{{ data.data.lastName }}</b-nav-item>
        </b-nav>
      </template>

      <DxColumn data-field="firstName" caption="First Name" cell-template="firstName" />
      <template #firstName="{ data }">
        <b-nav pills>
          <b-nav-item :to="`/emr/Patient/${data.data.personId}`">{{ data.data.firstName }}</b-nav-item>
        </b-nav>
      </template>

      <DxColumn data-field="middleName" caption="Middle" />
      <DxColumn data-field="dateOfBirth" caption="DOB" cell-template="formatDate-template" />
      <DxColumn data-field="lastSeen" caption="Last Seen" cell-template="formatDate-template" />
      <DxColumn data-field="lastSeenBy" caption="Last Seen by" />
      <DxColumn data-field="nextAppointment" caption="Next Appointment" sort-order="desc" cell-template="formatDate-template" />
      <DxColumn data-field="taskCount" alignment="left" caption="Task Count" />

      <DxExport :enabled="true" />
      <DxSearchPanel :visible="true" />

      <DxPaging :enabled="true" :pageSize="50" />

      <DxHeaderFilter :visible="false" />
      <DxFilterRow :visible="false" />
      <DxLoadPanel :enabled="true" />

      <template #formatDate-template="{ data }">
        <span>{{ useFormatDate(data.text) }}</span>
      </template>
    </DxDataGrid>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, reactive } from "vue";
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxFilterRow,
  DxHeaderFilter,
  DxLoadPanel,
  DxSelection,
  DxExport,
  DxSearchPanel,
  DxColumnFixing,
  DxScrolling,
  DxToolbar,
  DxItem,
} from "devextreme-vue/data-grid";

import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import { usePatientStore } from "@/stores/patientStore";
import moment from "moment";

const patientStore = usePatientStore();

// & PROPS
const props = defineProps({
  records: {
    type: Array,
    required: true,
    default: () => [],
  },
  fields: {
    type: Array,
    required: false,
    default: () => [],
  },
  idField: {
    type: String,
    required: false,
  },
  selected: {
    type: Array,
    required: false,
  },
  handleOnCellPrepared: {
    type: Function,
    required: false,
  },
  FromLabs: {
    type: Boolean,
    required: false,
  },
  selectedFileName: {
    type: String,
    default: () => {},
  },
});

// ~ string Template TEST
const name = "thomas";
const job = "Window Washer";

const cCatStrings = "Hi my name is " + name + " and I am a " + job;
// * USEs  BACKTICKs
const templateSTRING = `Hi, my name is  is     ${name}`;

// & COMPOSIBLEs
import { useMouse } from "@/use/mouse.js";
import { useFormatDate } from "@/use/formatDate.js";

const { x, y } = useMouse();

// const dateCh = useFormatDate()

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);
const currentTask = reactive({});

function onCellPrepared(e) {
  if (!props.handleOnCellPrepared) return;
  props.handleOnCellPrepared(e);
}
function onExporting(e) {
  // console.clear();
  // console.log(e);
  // console.log(e.fileName);
  // * NEW FILENAME BINDING
  e.fileName = props.selectedFileName;
  // console.log(e.fileName);

  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet("Main sheet");
  exportDataGrid({
    component: e.component,
    worksheet: worksheet,
    customizeCell: function (options) {
      options.excelCell.font = { name: "Arial", size: 12 };
      options.excelCell.alignment = { horizontal: "left" };
    },
  }).then(function () {
    // console.log(" 												  ... saveAS");

    workbook.xlsx.writeBuffer().then(function (buffer) {
      saveAs(new Blob([buffer], { type: "application/octet-stream" }), e.fileName + ".xlsx");
    });
  });
}
function onToolbarPreparing(e) {
  var item = e.toolbarOptions.items.find((item) => item.name === "exportButton");

  if (item) {
    // Check if 'item' was found
    item.showText = "always";
  } else {
    console.warn("Toolbar item with name 'exportButton' not found.");
    // Optionally handle the case where the item is not found,
    // e.g., add the item if it's missing or log a warning.
  }

  const toolbarItems = e.toolbarOptions.items;

  // Iterate over the toolbar items and change the location
  toolbarItems.forEach((item) => {
    if (item.name === "searchPanel" || item.name === "exportButton") {
      item.location = "before";
    }
  });
}

onMounted(() => {
  //   console.clear();
  // console.log("onMounted() :     								  WidgetSummaryGrid  >>>>");
  // console.log(" prop   records ");
  // console.log("props : ");
  // console.log(props);
  // console.log({ ...props.records });
});
</script>

<style lang="scss" scoped>
.page-grid-wrapperDash {
  background: transparent;
  padding: 0px;
  overflow: auto;
}

.detailsSlot {
  background: transparent; // #007f8b !important;
  padding: 0px;
}

a {
  text-decoration: none;
  font-weight: bolder;
  // color: #83ff7d;
  //background:#dcf1de;
}

// .DxSelection td {
// 	background: rgb(227, 255, 17) !important;
// }
// .dx-row-focused.dx-data-row > td:not(.dx-focused),
//.dx-row-focused.dx-data-row > tr > td:not(.dx-focused) ,
//.dx-row-focused.dx-data-row>tr>td>a:not(.dx-focused) {
//background-color: #e59807; //95c6ef
//color: rgb(255, 251, 9);
//}->

// .dx-datagrid-rowsview
// 	.dx-row-focused.dx-data-row
// 	.dx-command-edit:not(.dx-focused)
// 	.dx-link,
// .dx-datagrid-rowsview .dx-row-focused.dx-data-row > td:not(.dx-focused),
// .dx-datagrid-rowsview .dx-row-focused.dx-data-row > tr > td:not(.dx-focused) {
// 	background-color: #bcb91a;
// 	color: rgb(151, 27, 176);
// }
//a.nav-link {
//display: block;
// background-color: #bcb91a;
//  padding: 0%;
// PRORITY ICON   AREA   background: darkblue;
//}
</style>
